export const LIST_SLA_RESULT_REQUEST = 'LIST_SLA_RESULT_REQUEST'
export const LIST_SLA_RESULT_SUCCESS = 'LIST_SLA_RESULT_SUCCESS'
export const LIST_SLA_RESULT_FAIL = 'LIST_SLA_RESULT_FAIL'

export const EXPORT_SLA_RESULT_REQUEST = 'EXPORT_SLA_RESULT_REQUEST'
export const EXPORT_SLA_RESULT_SUCCESS = 'EXPORT_SLA_RESULT_SUCCESS'
export const EXPORT_SLA_RESULT_FAIL = 'EXPORT_SLA_RESULT_FAIL'

export const LIST_EXPORT_SLA_RESULT_REQUEST = 'LIST_EXPORT_SLA_RESULT_REQUEST'
export const LIST_EXPORT_SLA_RESULT_SUCCESS = 'LIST_EXPORT_SLA_RESULT_SUCCESS'
export const LIST_EXPORT_SLA_RESULT_FAIL = 'LIST_EXPORT_SLA_RESULT_FAIL'

export const LIST_BULK_SLA_REQUEST = 'LIST_BULK_SLA_REQUEST'
export const LIST_BULK_SLA_SUCCESS = 'LIST_BULK_SLA_SUCCESS'
export const LIST_BULK_SLA_FAIL = 'LIST_BULK_SLA_FAIL'

export const DETAIL_BULK_SLA_REQUEST = 'DETAIL_BULK_SLA_REQUEST'
export const DETAIL_BULK_SLA_SUCCESS = 'DETAIL_BULK_SLA_SUCCESS'
export const DETAIL_BULK_SLA_FAIL = 'DETAIL_BULK_SLA_FAIL'

export const DETAIL_SLA_EXTENDED_REQUEST = 'DETAIL_SLA_EXTENDED_REQUEST'
export const DETAIL_SLA_EXTENDED_SUCCESS = 'DETAIL_SLA_EXTENDED_SUCCESS'
export const DETAIL_SLA_EXTENDED_FAIL = 'DETAIL_SLA_EXTENDED_FAIL'

export const POST_EXTENDED_SLA_REQUEST = 'POST_EXTENDED_SLA_REQUEST'
export const POST_EXTENDED_SLA_SUCCESS = 'POST_EXTENDED_SLA_SUCCESS'
export const POST_EXTENDED_SLA_FAIL = 'POST_EXTENDED_SLA_FAIL'
